import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Domain from "@material-ui/icons/Domain";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import AttendanceLocalDepartmentGuicheServiceListTableActions from "./components/table-action";
// import SearchField from "../../../../../../../../../../../components/search-field";
import { useAttendanceLocalStyles } from "../../../../../../../../../../../styles";
import { useAttendanceLocalDepartmentQueueServiceListStyles } from "./styles";
import CustomPagination from "../../../../../../../../../../../../../Components/pagination";
import { dateformat } from "../../../../../../../../../../../../../utils/dateFormat";
import { useBreadcrumbs } from "../../../../../../../../../../../../../contexts/breadcrumb";
import EmptyState from "../../../../../../../../../../../../../Components/EmptyState";
import { useAttendanceLocalDepartmentGuicheServiceList } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/service/list";
import ServiceFormCreate from "../form/create";

export default function AttendanceLocalDepartmentGuicheServiceList() {
    const history = useHistory();
    const { slug, department_id, guiche_id } = useParams<{
        slug: string;
        department_id: string;
        guiche_id: string
    }>();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { classes } = useAttendanceLocalDepartmentQueueServiceListStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: serviceList, isLoading } = useAttendanceLocalDepartmentGuicheServiceList({
        guiche: Number(guiche_id),
    });

    const isEmpty = (serviceList?.results ?? []).length === 0;

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
                {
                    label: "Setor",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}`,
                    icon: Domain,
                },
                {
                    label: "Serviços do Guichê",
                    path: "",
                }
            ];
        });
    }, [setBreadcrumbs, slug, department_id]);

    return (
        <Box>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            <Box className={classes.header}>
                <Typography className={classes.title}>
                    Serviços do Guichê
                </Typography>
                <ServiceFormCreate
                    unidade_slug={slug}
                    setor_unidade={Number(department_id)}
                    guiche_id={Number(guiche_id)}
                />
            </Box>
            <Paper elevation={3} style={{ overflow: "hidden" }}>
                {/* <SearchField /> */}
                <TableContainer className={defaultClasses.tableContainer}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={defaultClasses.tableTH}>
                                    Serviço
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Presencial
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Online
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Adicionado
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {serviceList?.results.map((service) => (
                                <TableRow key={service.id} hover>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {service.servico.servico.titulo}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <Box
                                            className={`${defaultClasses.badge} ${service.servico.atendimento
                                                ? defaultClasses.active
                                                : defaultClasses.inactive
                                                }`}
                                        >
                                            {service.servico.atendimento ? "Sim" : "Não"}
                                        </Box>
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <Box
                                            className={`${defaultClasses.badge} ${service.servico.agendamento
                                                ? defaultClasses.active
                                                : defaultClasses.inactive
                                                }`}
                                        >
                                            {service.servico.agendamento ? "Sim" : "Não"}
                                        </Box>
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(service.created_at, true)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <AttendanceLocalDepartmentGuicheServiceListTableActions
                                            service={service}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {isEmpty && (
                        <EmptyState
                            loading={isLoading}
                            loadingText="Carregando serviços..."
                            message="Nenhum serviço encontrado."
                        />
                    )}
                </TableContainer>
                <Box className={defaultClasses.paginationContainer}>
                    <CustomPagination
                        count={serviceList?.count}
                        page={serviceList?.current}
                        totalPages={serviceList?.total_pages}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
